import React, { useState, useEffect, useContext } from "react";
import AccountingLogTable from "./AccountingLogTable";

function AccountingLog() {
  return (
    <div className="Plans">
      <div className="main">
        <AccountingLogTable />
      </div>
    </div>
  );
}

export default AccountingLog;
